// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import {
    MutationCreateContractParticipantArgs,
    MutationDeleteContractParticipantArgs,
} from '../../../mdqx-graphql-types';
import { ContractParticipantEntity } from '../../../entities/mdqx/contract-participant.entity';

export enum ContractParticipantActionTypes {
    GetRequest = '[ContractParticipants] Get Request',
    GetResponse = '[ContractParticipants] Get Response',
    PostRequest = '[ContractParticipant] Post Request',
    PostResponse = '[ContractParticipant] Post Response',
    DeleteRequest = '[ContractParticipant] Delete Request',
    DeleteResponse = '[ContractParticipant] Delete Response',
}

export class GetContractParticipantsRequest implements Action {
    readonly type = ContractParticipantActionTypes.GetRequest;
}

export class GetContractParticipantsResponse implements Action {
    readonly type = ContractParticipantActionTypes.GetResponse;
    constructor(public Payload: ContractParticipantEntity[]) {}
}

export class PostContractParticipantRequest implements Action {
    readonly type = ContractParticipantActionTypes.PostRequest;
    constructor(public Payload: MutationCreateContractParticipantArgs) {}
}

export class PostContractParticipantResponse implements Action {
    readonly type = ContractParticipantActionTypes.PostResponse;
    constructor(public Payload: ContractParticipantEntity) {}
}

export class DeleteContractParticipantRequest implements Action {
    readonly type = ContractParticipantActionTypes.DeleteRequest;
    constructor(public Payload: MutationDeleteContractParticipantArgs) {}
}

export class DeleteContractParticipantResponse implements Action {
    readonly type = ContractParticipantActionTypes.DeleteResponse;
    constructor(public Payload: number) {}
}

export type ContractParticipantActions =
    | GetContractParticipantsRequest
    | GetContractParticipantsResponse
    | PostContractParticipantRequest
    | PostContractParticipantResponse
    | DeleteContractParticipantRequest
    | DeleteContractParticipantResponse;
